module.exports = __webpack_public_path__ + "img/589.0f0e2180.jpg";